import styled from 'styled-components'

const KasKrsStyleV12 = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-auto-flow: column;
  align-items: start;
  justify-content: start;

  .radio {
    grid-column: 1/2;
  }

  .radioGroup {
    height: 16px;
    margin-bottom: 7px;
  }

  .text {
    width: 184px;
    > div {
      margin: 7px 0 0 0;
    }
  }

  .caption {
    font-size: 11px;
    line-height: 1.45;
    letter-spacing: 0.4px;
    color: ${props => props.theme.black38};
  }

  .buttonGUS {
    margin-top: 18px;
  }
`
export default KasKrsStyleV12
